export const selectTimeInStageData = (state) => state.capture.timeInStage.data;

export const selectTimeInStageLoading = (state) =>
  state.capture.timeInStage.isLoading;

export const selectTimeInStageError = (state) => state.capture.timeInStage.error;
